/**
 * The campaign notifications are timed in hours before the campaign starts or ends, but the
 * server stores whole minutes, the unit every other notification timing uses. These convert
 * between the two.
 */

/** The shortest lead time the server accepts. Zero would mean "never", which the switches do. */
export const MIN_LEAD_MINUTES = 1;

/** 60 -> "1", 6 -> "0.1", 90 -> "1.5". Two decimals at most. */
export const hoursFromMinutes = (minutes) => String(Math.round(((minutes || 0) / 60) * 100) / 100);

/**
 * Whole minutes for a typed number of hours, or `null` when it cannot be used: blank, not a
 * number, zero or negative. Rounds to the nearest minute, so 0.1 hour is 6 minutes, and never
 * returns less than one minute.
 */
export const minutesFromHours = (value) => {
  const hours = Number(value);

  if (value === '' || value === null || value === undefined || !(hours > 0)) return null;

  return Math.max(MIN_LEAD_MINUTES, Math.round(hours * 60));
};
